// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_RESET_SEARCH_TOTAL,
} from './constants';

export function resetSearchTotal() {
  return {
    type: COMMON_RESET_SEARCH_TOTAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_RESET_SEARCH_TOTAL:
      return {
        ...state,
        fetchGetSearchDataTotal: 0,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/resetSearchTotal.js